import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#f0f0f0ff] text-[#70706eff] p-4">
            {/* Ícono grande */}
            <FontAwesomeIcon icon={faExclamationTriangle} beat className="text-yellow-500 text-6xl mb-4" />

            {/* Mensaje de error */}
            <h1 className="text-4xl font-bold mb-2 text-center">¡Página no encontrada!</h1>
            <p className="text-lg text-center mb-6">
                Lo sentimos, no pudimos encontrar la página que estás buscando. <br />
                Verifica la URL o regresa a la página principal.
            </p>

            {/* Botón para regresar */}
            <button
                onClick={() => navigate(-1)}
                className="px-4 py-1 bg-[#1f94c2ff] text-white rounded-md border border-[#6e787aff]"
            >
                Regresar
            </button>
        </div>
    );
};

export default ErrorPage;
